module.exports = __webpack_public_path__ + "tw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tw.svg
// module id = 857
// module chunks = 0